<template>
  <div>
    <wc-data-box
      title='Quote Amounts'
      titleIcon='mdi-currency-usd'
      titleIconColor='success'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Spring Cleanup</td>
            <td :class='project.project_detail.spring_cleanup_price ? dataValue : nullValue'>
              {{ project.project_detail.spring_cleanup_price | decMoney }}
            </td>
          </tr>
          <tr>
            <td :class='label'>Lawn Care</td>
            <td :class='project.project_detail.lawn_care_price ? dataValue : nullValue'>
              {{ project.project_detail.lawn_care_price | decMoney }}
            </td>
          </tr>
          <tr>
            <td :class='label'>Weed Control / Fertilizer</td>
            <td :class='project.project_detail.fertilizer_price ? dataValue : nullValue'>
              {{ project.project_detail.fertilizer_price | decMoney }}
            </td>
          </tr>
          <tr>
            <td :class='label'>Additional Work</td>
            <td :class='project.project_detail.additional_work_price ? dataValue : nullValue'>
              {{ project.project_detail.additional_work_price | decMoney}}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>
export default {
  name: 'lawn-quote-amounts',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right success--text pr-2',
    nullValue: 'text-right grey--text pr-2'
  }),
}
</script>